import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TriangleAlert } from 'lucide-react';
import { cn } from '@fortem-monorepo/js-utilities';
import { Alert, AlertDescription, AlertTitle } from '@fortem-monorepo/react-ui';
import { getErrorMessage, isFortemSDKError } from '@fortem-monorepo/web-sdk';
const CustomNoRowsOverlay = ({ getQuery }) => {
    const result = getQuery();
    return (_jsx("div", { className: cn('overflow-hidden p-4'), children: result?.error ? (_jsxs(Alert, { variant: 'default', children: [_jsx(TriangleAlert, {}), _jsxs("div", { className: 'text-left', children: [_jsx(AlertTitle, { children: "An Error has occurred" }), _jsx(AlertDescription, { children: isFortemSDKError(result.error)
                                ? getErrorMessage(result.error)
                                : 'If not done already, please contact Tech and share a link to this page.' })] })] })) : (_jsx(_Fragment, { children: "No Rows To Show" })) }));
};
/**
 * DEFAULT PLUGIN.
 *
 * This plugin enhances what is shown to the user when no rows are passed into AgGrid.
 *
 * This allows us to customise what is shown when errors occur.
 */
export const NoRowsOverlayPlugin = () => {
    return {
        augmentOptions: (options, ctx) => {
            return {
                ...options,
                noRowsOverlayComponentParams: {
                    getQuery: () => ctx.query,
                },
                noRowsOverlayComponent: CustomNoRowsOverlay,
            };
        },
    };
};
